<template>
  <div id="app">
    <Header></Header>
    <Breadcrumb></Breadcrumb>
    <Head></Head>
    <Main></Main>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from './components/Header.vue'
import Breadcrumb from './components/Breadcrumb.vue'
import Head from './components/Head.vue'
import Main from './components/Main.vue'
import Footer from './components/Footer.vue'

export default {
  name: 'App',
  components: {
    Header: Header,
    Breadcrumb: Breadcrumb,
    Head: Head,
    Main: Main,
    Footer: Footer,
  },

  mounted: function() {
    const ua = navigator.userAgent.toLowerCase();
    const app = document.getElementById('app')

    if ((ua.indexOf('iphone') > -1 && ua.indexOf('ipad') == -1) || ua.indexOf('ipod') > -1 ){
      app.classList.add('ios')
    }else if(ua.indexOf('android') > -1 && (ua.indexOf('mobile') > -1)){
      app.classList.add('android')
    }else {
    //void(0)
    }
  }
}
</script>


<style>
</style>
